/** Reusable slide-in animation component — import, never remake. */

import type { ReactNode } from "react";
import { useCurrentFrame, interpolate } from "remotion";

interface SlideInProps {
  children: ReactNode;
  direction?: "left" | "right" | "up" | "down";
  delay?: number;
  duration?: number;
}

export function SlideIn({
  children,
  direction = "up",
  delay = 0,
  duration = 20,
}: SlideInProps) {
  const frame = useCurrentFrame();
  const progress = interpolate(frame - delay, [0, duration], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const offset = interpolate(progress, [0, 1], [40, 0]);
  const opacity = progress;

  const transform = {
    left: `translateX(-${offset}px)`,
    right: `translateX(${offset}px)`,
    up: `translateY(${offset}px)`,
    down: `translateY(-${offset}px)`,
  }[direction];

  return <div style={{ transform, opacity }}>{children}</div>;
}
